Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "divider531288443",
  {"root":"divider531288443--root"},
  "",
  2,
  "divider531288443"
);

